/**
 * @file automatically generated from MApp.Endpoints.VectorContentController
 */ 

import { MetadataClient } from '../metadataClient';
import { IVectorImport, ISaveVectorImport, ISaveVector, IVector, IVectorListItem, IGeometryTypeFilter, ISaveVectorSet, IPostSaveDataset, IVectorSet, IVectorSetListItem, IValidationResult } from '../models';

export class VectorContentClient extends MetadataClient {

    public static getVectorImports(connectionId: string) {
        return MetadataClient.ajax<IVectorImport[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/vector/${encodeURIComponent(connectionId)}/imports`)
        );
    }

    public static saveVector(vectors: ISaveVectorImport[]) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/vector`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(vectors)
			})
        );
    }

    public static updateVector(id: string, vector: ISaveVector) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/vector/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(vector)
			})
        );
    }

    public static calculateBounds(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/vector/${encodeURIComponent(id)}/bounds`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT'
			})
        );
    }

    public static deleteVector(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/vector/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getVector(id: string) {
        return MetadataClient.ajax<IVector>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/vector/${encodeURIComponent(id)}`)
        );
    }

    public static getVectors() {
        return MetadataClient.ajax<IVectorListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/vector`)
        );
    }

    public static getVectorsByGeometryType(filter: IGeometryTypeFilter) {
        return MetadataClient.ajax<IVectorListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/content/vector/geometrytype`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(filter)
			})
        );
    }

    public static getVectorFields(id: string) {
        return MetadataClient.ajax<string[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/vector/${encodeURIComponent(id)}/fields`)
        );
    }

    public static saveVectorSet(vectorSet: ISaveVectorSet) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/vectorsets`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(vectorSet)
			})
        );
    }

    public static replaceVectorSet(id: string, vectorSet: ISaveVectorSet) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/vectorsets/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(vectorSet)
			})
        );
    }

    public static saveVectorSetDataset(vectorSetId: string, dataset: IPostSaveDataset) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/vectorsets/datasets/${encodeURIComponent(vectorSetId)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(dataset)
			})
        );
    }

    public static reorderVectorSet(id: string, datasetIds: string[]) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/vectorsets/${encodeURIComponent(id)}/reorder`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(datasetIds)
			})
        );
    }

    public static deleteVectorSetDataset(id: string, datasetId: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/vectorsets/${encodeURIComponent(id)}/datasets/${encodeURIComponent(datasetId)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getVectorSet(id: string) {
        return MetadataClient.ajax<IVectorSet>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/vectorsets/${encodeURIComponent(id)}`)
        );
    }

    public static getVectorSetList() {
        return MetadataClient.ajax<IVectorSetListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/vectorsets/list`)
        );
    }

    public static getVectorSets() {
        return MetadataClient.ajax<IVectorSet[]>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/vectorsets`)
        );
    }

    public static deleteVectorSet(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/vectorsets/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static isValidVectorSet(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/vectorsets/isvalid/${encodeURIComponent(name)}`)
        );
    }

    public static updateVectorBounds(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/content/vector/${encodeURIComponent(id)}/updatebounds`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST'
			})
        );
    }
}
